
import img1 from "../../../../assets/img/Services/StrategicConsulting/108532.jpg";

import {AiOutlineDatabase, AiOutlineUsergroupAdd} from "react-icons/ai"


export default function PaymentServices() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
             <div className="flex flex-col mb-6 justify-center lg:justify-center lg:flex-row md:mb-8">
          <h2 className="max-w-lg mb-5 font-sans text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl sm:leading-none md:mb-6 group">
            <span className="inline-block mb-1 sm:mb-4">Our Approach</span>
            <div className="h-1 ml-auto duration-300 origin-left transform bg-primary scale-x-30 group-hover:scale-x-100" />
          </h2>
         
        </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
            AI Discovery and Assessment
            </h1>
            <p className="text-lg text-gray-600">
              Analyze your current capabilities and identify opportunities for AI and ML integration.    
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <AiOutlineDatabase className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Data Readiness Check</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Evaluate if your data is structured and ready for AI implementation.
               </p>
            </div>

            {/* Feature 3 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <AiOutlineUsergroupAdd className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">AI Skill Assessment</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Analyze current team capabilities to handle AI and ML technologies.

                            </p>
            </div>

          </div>
        </div>

        <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
      </div>
    </div>
  )
}